import { render, staticRenderFns } from "./province-add-or-update.vue?vue&type=template&id=6803ff5f"
import script from "./province-add-or-update.vue?vue&type=script&lang=js"
export * from "./province-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports